import { format } from 'date-fns';

import { http } from '..';
import type { GetUserByIdResponseDto, GetUsersResponseDto, UserStatus } from './types';

export const fetchAll = async (
  projectId: string,
  query: Record<string, string | number>,
): Promise<GetUsersResponseDto> => {
  const users = (await http
    .query(query)
    .get(`/admin/projects/${projectId}/users`)
    .json()) as GetUsersResponseDto;

  return {
    ...users,
    data: users.data.map((item) => ({ ...item, createdAt: format(item.createdAt, 'Pp') })),
  };
};

export const fetchById = async (
  projectId: string,
  userId: string,
): Promise<GetUserByIdResponseDto> => {
  return http.url(`/admin/projects/${projectId}/users/${userId}`).get().json();
};

export const updateStatus = async (projectId: string, userId: string, status: UserStatus) => {
  return http.url(`/admin/projects/${projectId}/users/${userId}/status`).put({ status }).res();
};
